<app-layout-page>
  <app-layout-header></app-layout-header>
  <app-layout-content class="content">
    <div class="image">
      <div class="large-icon-with-inset" aria-hidden="true">
        <img src="/assets/image/graphic/phone-camera.svg" class="large-icon">
        <mat-icon class="inset-icon color-error">error</mat-icon>
      </div>
    </div>
    <h2 [trans]="title">(title)</h2>
    <p [trans]="message">(message)</p>
    @if (code) {
      <p class="error-code">
        Code: <span>{{code}}</span>
      </p>
    }
  </app-layout-content>
</app-layout-page>
